import request from '@/utils/request'


export function getSelecotrData(source,param) {
  return request({
    url: `/api/selector?source=${source}&param=${param}`,
    method: 'get'
  })
}




export function gethospData(data) {
  return request({
    url: `/api/drugstore/get-hosp-list`,
    method: 'post',
    data
  })
}